<template>
    <p :class="['pagination-total sm:mx-auto sm:w-auto', wrapperClass]">
        <span>
          <strong class="page-number">{{ pagination.total }} 件中</strong>
          {{ pageElementStart }}～{{ pageElementEnd }}件表示
        </span>
    </p>
  </template>
  
  <script>
  
  export default {
    name: 'PaginationItemCount',
    props: {
      wrapperClass: {
            type: String,
            default: ""
        },
      pagination: {
        type: Object,
        required: true,
      }
    },
    computed: {
        pageElementStart() {
            const { page, size, total } = this.pagination
            if (+total === 0) return 0
            return (page - 1) * size + 1
        },
        pageElementEnd() {
            const { total, page, size } = this.pagination
            return total > page * size ? page * size : total
        },
    } 
  };
  </script>